<template lang="pug">
#contratos-exportacao-tabela
    .tabela-relatorio-exportacao
        el-table(
            :key="listagemTableKey('contratos', tabelaData, paginacao.pagina + 1)",
            :data='tabelaData',
            ref='contratos-exportacao-table',
            v-loading='carregando',
            stripe,
            :default-sort='{ prop: "dataAverbacao", order: "descending" }',
            @sort-change='sortChangeRequest',
            style='width: 100%',
        )
            el-table-column(
                prop='numero',
                :label='$t("relatorioExportacao.detalhe.numeroContrato")',
                align='left',
                sortable
            )
                template(slot-scope='scope')
                    | {{ scope.row.numero || '-' }}

            el-table-column(
                prop='tipo',
                :label='$t("relatorioExportacao.detalhe.tipo")',
                align='left',
                sortable
            )
                template(slot-scope='scope')
                    | {{ serializeName(scope.row.tipo) || '-' }}

            el-table-column(
                :label='$t("relatorioExportacao.detalhe.acoes")',
                align='center',
                width='100'
            )
                .template.d-flex.justify-content-center.tabela-gestao-icone(
                    slot-scope='scope'
                )
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-download',
                                :disabled='!scope.row.relatorioPronto',
                                @click.native='exportarRelatorioContrato(scope.row)'
                            )
                                | {{ $t('relatorioExportacao.lista.download') }}

            template(slot='empty')
                el-empty(:description='$t("relatorioExportacao.lista.listaVazia")')

    .tabela-relatorio-exportacao__paginacao
        span.pagina
            | {{ paginacao.total }} {{ paginacao.total > 1 ? $t('relatorioExportacao.lista.listaVazia') : $t('relatorioExportacao.lista.listaVazia') }}

        el-pagination(
            background,
            :page-size='paginacao.itensPorPagina',
            :pager-count='5',
            :current-page.sync='paginacao.pagina + 1',
            layout='prev, pager, next',
            :total='paginacao.total',
            @current-change='mudarPagina'
        )
</template>

<script>
import { serializeName } from '@/modules/relatorio-exportacao/utils';
import services from '@/modules/relatorio-exportacao/services/RelatorioService';

export default {
    name: 'ContratosTabela',
    props: {
        tabelaData: {
            type: Array,
            required: true
        },
        detalhes: {
            type: Object,
            required: true
        },
        paginacao: {
            type: Object,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        }
    },
    methods: {
        serializeName,
        mudarPagina(novaPagina) {
            this.$emit('mudarPagina', novaPagina - 1);
        },
        sortChangeRequest(column) {
            const order = {
                prop: column.prop,
                order: column.order === 'ascending' ? 'asc' : 'desc'
            };

            this.$emit('ordenarTabela', order);
        },
        async exportarRelatorioContrato(row) {
            try {
                const params = {
                    idNavio: this.detalhes.id,
                    idContrato: row.id
                };

                await services.downloadRelatorioContrato(params);
                this.$notify.success({
                    message: this.$t('relatorioExportacao.lista.downloadSucesso')
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t('relatorioExportacao.lista.downloadErro')
                });
            }
        }
    }
};
</script>
<style lang="scss">
#contratos-exportacao-tabela {
    box-shadow: 0 0 10px rgb(0 0 0 / 10%);
    border-radius: 10px;

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;

        thead.has-gutter {
            height: 67px;

            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }
    }

    .el-table__cell {
        font-size: 12px;
    }

    .is-leaf {
        font-size: 13px;
    }

    .status-processamento {
        max-width: 148px;
        word-break: break-word;
        font-size: 13px;
        line-height: 17px;
    }

    .tabela-relatorio-exportacao__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        .pagina {
            color: var(--primary);
            font-weight: 600;
        }
    }

    .tabela-gestao-icone {
        i {
            font-size: 23px;
            cursor: pointer;
        }
    }
}
</style>
